import apiClient from './client'
import { apiEndpoints } from '@/config/api'

/**
 * Account API Module
 * 
 * Handles all account-related API operations.
 * All endpoints require authentication.
 */

export const accountApi = {
  /**
   * Get account dashboard
   * @returns {Promise} Dashboard data
   */
  async getDashboard() {
    const response = await apiClient.get(apiEndpoints.account.dashboard)
    return response.data
  },

  /**
   * Get order history
   * @param {number} page - Page number for pagination
   * @returns {Promise} Orders list
   */
  async getOrders(page = 1) {
    const response = await apiClient.get(apiEndpoints.account.orders, { params: { page } })
    return response.data
  },

  /**
   * Get order details
   * @param {number} orderId - Order ID
   * @returns {Promise} Order details
   */
  async getOrder(orderId) {
    const response = await apiClient.get(apiEndpoints.account.order(orderId))
    return response.data
  },

  /**
   * Get user profile
   * @returns {Promise} Profile data
   */
  async getProfile() {
    const response = await apiClient.get(apiEndpoints.account.profile)
    return response.data
  },

  /**
   * Update user profile
   * @param {Object} data - Profile data
   * @param {string} data.first_name - First name
   * @param {string} data.last_name - Last name
   * @param {string} data.phone - Phone number
   * @param {string} data.company - Company name
   * @param {string} data.billing_address - Billing address
   * @param {string} data.billing_city - Billing city
   * @param {string} data.billing_state - Billing state
   * @param {string} data.billing_country - Billing country
   * @param {string} data.billing_postal_code - Billing postal code
   * @param {string} data.shipping_address - Shipping address
   * @param {string} data.shipping_city - Shipping city
   * @param {string} data.shipping_state - Shipping state
   * @param {string} data.shipping_country - Shipping country
   * @param {string} data.shipping_postal_code - Shipping postal code
   * @param {string} data.password - New password (optional)
   * @param {string} data.password_confirmation - Password confirmation
   * @returns {Promise} Updated profile
   */
  async updateProfile(data) {
    const response = await apiClient.put(apiEndpoints.account.profile, data)
    return response.data
  },
}

export default accountApi
